// extracted by mini-css-extract-plugin
module.exports = {"table":"Taxonomies-module__table___HY0IY"};